import { render, staticRenderFns } from "./MagicLinkPre.vue?vue&type=template&id=6bb4a82b&scoped=true&"
import script from "./MagicLinkPre.vue?vue&type=script&lang=js&"
export * from "./MagicLinkPre.vue?vue&type=script&lang=js&"
import style0 from "./MagicLinkPre.vue?vue&type=style&index=0&id=6bb4a82b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb4a82b",
  null
  
)

export default component.exports